import { setLocalStorage, getLocalStorage } from '@/utils/localStorage'
import { isEmpty } from 'lodash-es'
import { DDL_CODE_KEY } from '@/components/DeepLinkBanner/constant'

/**
 * @description: 获取深度链接 banner ddlCode
 * @param {*} to 路由参数
 * @param {*} from 路由参数
 * @param {*} next 路由守卫 next 函数
 * @return {*}
 */
const getDeepLinkBannerDDLCode = (to, from, next) => {
  try {
    /**
     * 1. 优先从进站链接获取，
     * 2. 如果没有，从 localStorage 获取，有可能是跳转页面或在别的页面刷新了
     * 3. 如果都没有，则不展示 DeepLinkBanner
     */
    const currentParams = new URLSearchParams(window.location.search)
    const ddlCode = currentParams.get('ddlCode') || getLocalStorage(DDL_CODE_KEY)
    setLocalStorage(DDL_CODE_KEY, !isEmpty(ddlCode) ? ddlCode : '')
    next()
  } catch (error) {
    next()
  }
}

export { getDeepLinkBannerDDLCode }
